import { FileText, Phone, Mail, Users as UsersIcon } from 'lucide-react';

export const API = `${window.location.origin}/api`;

export const STAGES = [
  { id: 'new_inquiry', label: 'New Inquiry', color: 'bg-blue-500', description: 'Initial contact received' },
  { id: 'discovery_pending', label: 'Discovery Pending', color: 'bg-cyan-500', description: 'Awaiting discovery call' },
  { id: 'strategy_call_booked', label: 'Strategy Call Booked', color: 'bg-indigo-500', description: 'Strategy call scheduled' },
  { id: 'qualified_lead', label: 'Qualified Lead', color: 'bg-purple-500', description: 'Qualified and engaged' },
  { id: 'proposal_sent', label: 'Proposal Sent', color: 'bg-yellow-500', description: 'Proposal delivered' },
  { id: 'client_won', label: 'Client Won', color: 'bg-green-500', description: 'Deal closed, booked' },
  { id: 'onboarding', label: 'Onboarding', color: 'bg-teal-500', description: 'Onboarding in progress' },
  { id: 'client_lost', label: 'Client Lost', color: 'bg-gray-500', description: 'Opportunity closed lost' },
];

export const ACTIVITY_TYPES = [
  { id: 'note', label: 'Note', icon: FileText },
  { id: 'call', label: 'Phone Call', icon: Phone },
  { id: 'email', label: 'Email', icon: Mail },
  { id: 'meeting', label: 'Meeting', icon: UsersIcon },
];
